// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"P9bQ1ydayXdHzR5qfX_PP","successModal":"aBRb1EXXaIr-MAmkinXcB","title":"_1mvYzA4IRZN4GWjoCM9Vl-","image":"_1mwjbHFP8PNko9CF1U0SgO","subtitle":"_1jGMexGTEcclqTSBzzCNW3"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EditCompanyByOwner/EditCompanyByOwner.scss
// module id = 1815
// module chunks = 0